import styles from './style.module.scss';

interface Props {
    salary: string | undefined;
    data: any | null;
    visaStatus: string | undefined;
};

export default function PersonalInformation(props: Props) {
    const { data, salary, visaStatus } = props;

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>Personal information</span>
                </div>
                <div className={styles.content_main}>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Full name</span>
                        <span className={styles.content_main_row_val}>{data?.firstName} {data?.lastName}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Phone number</span>
                        <span className={styles.content_main_row_val}>{data?.phoneNumber}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Preferred name</span>
                        <span className={styles.content_main_row_val}>{data?.preferrdName || '----'}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Email</span>
                        <span className={styles.content_main_row_val}>{data?.email}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>DOB</span>
                        <span className={styles.content_main_row_val}>{data?.birthdate}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>City</span>
                        <span className={styles.content_main_row_val}>{data?.city || '----'}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Country</span>
                        <span className={styles.content_main_row_val}>{data?.country || '----'}</span>
                    </div>
                    {/* <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Address</span>
                        <span className={styles.content_main_row_val}>{data?.address || '----'}</span>
                    </div> */}
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Zip code</span>
                        <span className={styles.content_main_row_val}>{data?.zipCode || '----'}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>State</span>
                        <span className={styles.content_main_row_val}>{data?.state || '----'}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>LinkdIn link</span>
                        <span className={styles.content_main_row_val}>{data?.linkedinLink || '----'}</span>
                    </div>
                </div>
            </div>
            <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>Salary & visa</span>
                    <div className={styles.content_headbar_actions}>

                    </div>
                </div>
                <div className={styles.content_main}>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Salary expectation</span>
                        <span className={styles.content_main_row_val}>
                            {data?.desiredAnnualSalaryRange ? `${data.desiredAnnualSalaryRange}$` : '----'}
                        </span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>e.g. H-1B visa status requirement</span>
                        <span className={styles.content_main_row_val}>{data?.requireSponsorshipVisa}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
